import {
  Button,
  FileUpload,
  Flex,
  FlexItem,
  Form,
  FormGroup,
  PageSection,
} from '@patternfly/react-core'
import * as React from 'react'
import styled from 'styled-components'

const FileUploadContainer = styled.div`
  #file-upload-filename {
    width: 25rem;
  }

  .pf-c-button:last-of-type {
    display: none;
  }
`

interface FileUploadComponentProps {
  onFileChange: (
    fileName: string,
    event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLElement>,
    file: File,
  ) => void
  onClear: () => void
  onUpload: () => void
  fileName: string
  file: File | undefined
}

export const BulkEnrolPatientsInProgram: React.FC<FileUploadComponentProps> = ({
  onFileChange,
  onClear,
  onUpload,
  fileName,
  file,
}) => {
  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLElement>,
    inputFile: File,
  ) => {
    onFileChange(inputFile.name, event, inputFile)
  }

  return (
    <PageSection>
      <Form>
        <FormGroup label="Import File" isRequired fieldId="file-upload">
          <Flex justifyContent={{ default: 'justifyContentFlexStart' }}>
            <FlexItem style={{ maxWidth: '30rem', width: '100%' }}>
              <FileUploadContainer>
                <FileUpload
                  id="file-upload"
                  filename={fileName}
                  onClearClick={onClear}
                  browseButtonText="Browse"
                  clearButtonText="Clear"
                  hideDefaultPreview
                  onFileInputChange={handleFileChange}
                />
              </FileUploadContainer>
            </FlexItem>
          </Flex>
        </FormGroup>
        <FormGroup>
          <Button isDisabled={!file} variant="primary" onClick={onUpload}>
            Upload
          </Button>
          <Button type="reset" variant="secondary" onClick={onClear}>
            Reset
          </Button>
        </FormGroup>
      </Form>
    </PageSection>
  )
}
